/**
 * Named tolerance regimes for collision and overlap checks.
 *
 * Two regimes cover all current use cases:
 *
 *   EXACT      — pipeline geometry (programmatically generated, high precision).
 *                Semantic tolerance is 0; the primitive's internal floating-point
 *                noise epsilon (FP_EPSILON) absorbs sub-mm drift from chained
 *                vector arithmetic. Used by S5 boundary, S5 fixture-overlap,
 *                S6 expansion, S6 apply-time overlap check.
 *
 *   FLOORPLAN  — user-drawn / scanned room geometry. Absorbs accumulated
 *                error from drag rounding, scan noise, coordinate conversion.
 *                Used by FPV drag/snap MTV, fixture-vs-fixture overlap,
 *                fixture-vs-boundary overlap.
 *
 * Callers reference regimes by name, not magnitude — intent is self-documenting
 * and future tightening (e.g., dropping FLOORPLAN toward EXACT after a
 * snap-to-wall precision improvement) is a single-constant change.
 */

const EXACT = 0;
const FLOORPLAN = 0.125 * 0.0254; // 1/8 inch in meters ≈ 0.003175 m

/**
 * Floating-point noise epsilon baked into the SAT primitives.
 * NOT a semantic tolerance — pure numerical hygiene to absorb drift from
 * chained wallNormal/wallDir arithmetic in pipeline expansion.
 *
 * Overlaps below this threshold are treated as numerical noise and reported
 * as zero. Distinct from caller-supplied `tolerance`, which sits on top.
 */
const FP_EPSILON = 1e-4; // 0.1 mm

module.exports = {
  EXACT,
  FLOORPLAN,
  FP_EPSILON,
};
